(function () {
  var root = document.querySelector("main.rosslyn");
  if (!root) return;

  var navLinks = root.querySelectorAll(".rosslyn-nav a[data-section]");
  var sections = [];
  navLinks.forEach(function (link) {
    var id = link.getAttribute("data-section");
    var el = document.getElementById(id);
    if (el) sections.push({ id: id, el: el, link: link });
  });

  function setActive(id) {
    navLinks.forEach(function (link) {
      link.classList.toggle("is-active", link.getAttribute("data-section") === id);
    });
  }

  if ("IntersectionObserver" in window && sections.length) {
    var navObserver = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) { return entry.isIntersecting; })
          .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; })[0];
        if (visible) setActive(visible.target.id);
      },
      { rootMargin: "-28% 0px -55% 0px", threshold: [0.1, 0.25, 0.5] }
    );
    sections.forEach(function (item) { navObserver.observe(item.el); });
  }

  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (event) {
      var id = link.getAttribute("href").slice(1);
      var target = document.getElementById(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      setActive(id);
    });
  });

  root.querySelectorAll("[data-card]").forEach(function (card) {
    var button = card.querySelector(".rosslyn-card__toggle");
    if (!button) return;
    button.addEventListener("click", function () {
      var open = card.classList.toggle("is-open");
      button.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function bindSectionVideo(video, target) {
    if (!video) return;
    if (reduceMotion) {
      video.pause();
      video.removeAttribute("autoplay");
      return;
    }
    if (!target || !("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var play = video.play();
            if (play && typeof play.catch === "function") play.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.05 }
    );
    observer.observe(target);
  }

  bindSectionVideo(document.querySelector(".rosslyn-bg video"), root.querySelector(".rosslyn-hero"));
  var arkansas = root.querySelector(".rosslyn-arkansas");
  bindSectionVideo(arkansas && arkansas.querySelector("video"), arkansas);

  var route = root.querySelector(".rosslyn-route");
  if (route && "IntersectionObserver" in window) {
    var routeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            route.classList.add("is-drawn");
            routeObserver.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    routeObserver.observe(route);
  }
})();
